import React from 'react';
import PropTypes from 'prop-types';

import Label from 'components/FormGroup/Label';
import RadioButton from 'components/FormGroup/RadioButton';

import colors from 'themes/Main';

import * as S from './styles';

const { gray02, darkBlue } = colors;

const MultipleChoice = ({
  hasLabelColor,
  labelText,
  options,
  handleChange,
  selectedOption,
}) => (
  <>
    <Label color={hasLabelColor ? darkBlue : gray02} text={labelText} />
    <S.Options>
      {options.map(option => (
        <RadioButton
          hasLabel
          labelText={option.label}
          name={option.name}
          id={option.name}
          value={option.value}
          onChange={handleChange}
          checked={option.value === selectedOption}
        />
      ))}
    </S.Options>
  </>
);

export default MultipleChoice;

MultipleChoice.defaultProps = {
  hasLabelColor: false,
};

MultipleChoice.propTypes = {
  hasLabelColor: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  ).isRequired,
  handleChange: PropTypes.func.isRequired,
  selectedOption: PropTypes.number.isRequired,
};
